
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

const notificationService = createApi({
  reducerPath: "notifications",
  tagTypes: "notifications",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin')
        ? JSON.parse(localStorage.getItem('admin')).token
        : null;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {

      getNotifications: builder.query({
        query: () => {
          return {
            url: "admin/notifications/get_notifications",
            method: "GET",
          };
        },
        providesTags: ["notifications"],
      }),

      sendNotification: builder.mutation({
        query: (data) => {
          return {
            url: "admin/notifications/send_notification",
            method: "POST",
            body: data,
          };
        },
        invalidatesTags: ["notifications"],
      }),
      deleteNotification: builder.mutation({
        query: (group_id) => {
          return {
            url: "admin/notifications/deleteGroupNotifications/" + group_id,
            method: "DELETE",
            // body: data,
          };
        },
        invalidatesTags: ["notifications"],
      }),

    };
  },
});
export const { useGetNotificationsQuery, useSendNotificationMutation, useDeleteNotificationMutation } = notificationService;
export default notificationService;
